import Vue from "vue";
import GlobalQuicksearch from "@global/global-elements/global-quicksearch/global-quicksearch"

import VueI18n from "vue-i18n";

export const globalQuicksearch = {
    init: () => {
        Vue.use(VueI18n)

        const globalQuicksearchShells = document.querySelectorAll('.global-quicksearch-wrapper');

        globalQuicksearchShells.forEach(shell => {
            new Vue({
                render: h => h(GlobalQuicksearch, {
                    props: {
                        api: window.globalQuicksearch.api,
                        parameter: {keyword: "tx_salbase9_search[q]", limitToCategories: window.globalQuicksearch.limitToCategories?.length ? window.globalQuicksearch.limitToCategories : 'all' },
                        resultsPageUrl: window.globalQuicksearch.resultsPageUrl,
                    },
                }),
                i18n: new VueI18n({
                    locale: 'gqs',
                    messages: {
                        gqs: window.jsI18N
                    }
                }),
            }).$mount(shell);
        })
    }
};
